<template>
  <div class="member-management">
    <div class="breadcrumb" style="background: #fff">成员管理</div>
    <div class="member-cn">
      <el-form :inline="true" :model="memberList">
        <el-form-item label="手机号:">
          <el-input v-model="memberList.phone" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名:">
          <el-input v-model="memberList.fullName" clearable></el-input>
        </el-form-item>
        <el-form-item class="fn-right">
          <el-button round @click="queryInfo.pageNum = 1, getAccount(queryInfo)">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="data-list">
        <el-table :data="tableList" border :row-class-name="rowClassName">
          <el-table-column prop="phone" label="手机号" min-width="180px">
          </el-table-column>
          <el-table-column label="姓名" min-width="180px">
            <template v-slot="scope">
              <span class="color-blue" @click="asd(scope.row)">{{ scope.row.fullName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="roleName" label="所属角色" min-width="180px"></el-table-column>
          <el-table-column prop="createdTime" label="添加时间" min-width="180px"></el-table-column>
          <el-table-column label="操作" min-width="180px" v-if="$hasPermission('crm:admin:user:removeAdmin')">
            <template v-slot="scope"><span class="color-blue" @click="deleteItem(scope.row)">删除</span></template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <CombinedDialog ref="dialogRef" @delete="deleteMember"></CombinedDialog>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    <!-- 修改姓名 -->
    <el-dialog :close-on-click-modal="false" title="修改姓名" :visible.sync="dialogVisible" width="30%">
      <span>姓名：</span>
      <el-input style="width:200px" v-model="editUserInfo.fullName" placeholder="请输入内容" clearable></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeUserName">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import VPagination from '@/components/Pagination/index'
import { roleGetUserListByRole, userUpdate } from '@/api/crm'
export default {
  name: 'member-management',
  components: {
    CombinedDialog, VPagination
  },
  data () {
    return {
      editUserInfo: {
        fullName: '',
        id: 0
      },
      dialogVisible: false,
      memberList: {
        phone: '',
        fullName: '',
        id: parseInt(this.$route.query.id)
      },
      tableList: [],
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  created () {
    this.getAccount(this.queryInfo)
  },
  methods: {
    asd (row) {
      this.editUserInfo.fullName = row.fullName
      this.editUserInfo.id = row.userId
      this.dialogVisible = true
    },
    changeUserName () {
      userUpdate(this.editUserInfo).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getAccount(this.queryInfo)
          this.dialogVisible = false
        }
      })
    },
    getAccount (val) {
      let _this = this
      roleGetUserListByRole({ pageNum: val.pageNum, pageSize: val.pageSize, searchUserByRoleVo: this.memberList }).then((res) => {
        if (res.data.success) {
          _this.queryInfo.total = res.data.data.total
          _this.tableList = res.data.data.records.map(a => {
            if (a.phone) {
              a.phone = _this.$msg.filterBridal(a.phone)
            }
            return a
          })
        } else {
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
      this.tableList[rowIndex].index = rowIndex
    },
    changeName (val) {
      this.$refs.dialogRef.show('changeCategoryName', '修改姓名', val, '', '/api/crm/admin/user/update/', '姓名')
    },
    deleteItem (val) {
      this.$refs.dialogRef.show('', '确定提示', '删除确定<br><span style="color: #999">是否确定删除</span>',
        'deleteAdmin', '', `${val.userId}`)
    },
    changePage (val) {
      this.queryInfo = val
      this.getAccount(this.queryInfo)
    },
    deleteMember () {
      this.getAccount(this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
.member-management {
  .el-form {
    background: #fff;
    padding-top: 22px;
    padding-left: 40px;

    .el-form-item {
      margin-right: 30px;

      .el-input__inner {
        width: 180px;
      }
    }
  }

  .data-list {
    background: #fbfbfb;
    padding: 20px;
  }
}
</style>
